var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":"Resources"}}),_c('div',{staticClass:"page-content col-12",domProps:{"innerHTML":_vm._s(_vm.resource.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }